import { createApi } from '@reduxjs/toolkit/query/react';
import { apiBaseQuery } from 'src/services/apiClient';

export const MINIMAL_RESOURCES_ACCESS_API_REDUCER_PATH = 'minimalResourcesAccessApi';

// Define a service for minimal resources access checks
export const minimalResourcesAccessApi = createApi({
    reducerPath: MINIMAL_RESOURCES_ACCESS_API_REDUCER_PATH,
    baseQuery: apiBaseQuery(),
    tagTypes: ['MinimalResourcesAccess'],
    endpoints: builder => ({
        checkMinimalResourcesAccess: builder.query({
            query: connectedAppId => ({
                url: `/iambff/v1/connected-apps/${connectedAppId}/corporate-structure/access-check`,
                method: 'GET',
            }),
            providesTags: ['MinimalResourcesAccess'],
            keepUnusedDataFor: 300, // Cache for 5 minutes
        }),
    }),
});

// Export hooks for usage in functional components
export const { useCheckMinimalResourcesAccessQuery } = minimalResourcesAccessApi;
